@if (type !== 'number') {
  @if (props['maskConfig']) {
    <input [type]="type"
      [formControl]="inputFormControl"
      class="form-control"
      autocomplete="off"
      [formlyAttributes]="field"
      [class.is-invalid]="showError"
      [maskito]="props['maskConfig']">
  } @else {
    <input [type]="type"
      [formControl]="inputFormControl"
      class="form-control"
      autocomplete="off"
      [formlyAttributes]="field"
      [class.is-invalid]="showError">
  }
} @else {
  <input type="number"
    [formControl]="inputFormControl"
    class="form-control"
    autocomplete="off"
    [formlyAttributes]="field"
    [class.is-invalid]="showError">
}
